import { render, staticRenderFns } from "./ProductManagement.vue?vue&type=template&id=1853ffa2&scoped=true&"
import script from "./ProductManagement.vue?vue&type=script&lang=js&"
export * from "./ProductManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProductManagement.vue?vue&type=style&index=0&id=1853ffa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1853ffa2",
  null
  
)

export default component.exports